import type { PageTourDefinition, PageTourStep } from '../../components/tour/pageTourTypes';
import { ROUTES } from '../routes';

/** Pasos del tour en el listado `/tesoreria/recibos`. */
const RECIBOS_LISTADO_STEPS: PageTourStep[] = [
  {
    targetId: 'recibos-nuevo',
    title: 'Nuevo recibo',
    body: 'Desde acá registrás una cobranza: elegís el cliente, los comprobantes que cancela y los medios con los que paga.',
    placement: 'bottom',
    pad: 6,
  },
  {
    targetId: 'recibos-exportar',
    title: 'Imprimir listado',
    body: 'Generá un PDF con los recibos que coinciden con los filtros aplicados.',
    placement: 'bottom',
    pad: 6,
  },
  {
    targetId: 'recibos-filtros',
    title: 'Filtros de búsqueda',
    body: 'Filtrá por número de recibo o comprobante, descripción, cliente o CUIT, rango de fechas, estado y sucursal.',
    placement: 'bottom',
    pad: 6,
  },
  {
    targetId: 'recibos-grilla',
    title: 'Listado de recibos',
    body: 'Acá ves los recibos emitidos con su cliente, importe y estado.',
    placement: 'top',
    pad: 4,
  },
  {
    targetId: 'recibos-acciones',
    title: 'Acciones por recibo',
    body: 'Desde cada fila podés imprimir el recibo, aplicar su saldo a comprobantes o ver sus aplicaciones, y usar el menú ⋮ para anularlo.',
    placement: 'left',
    pad: 6,
  },
];

/** Pasos del tour en el alta `/tesoreria/recibos/nuevo`. */
const RECIBO_NUEVO_STEPS: PageTourStep[] = [
  {
    targetId: 'recibo-cliente',
    title: 'Cliente',
    body: 'Buscá el cliente por número, nombre, razón social o CUIT. Al elegirlo se cargan sus comprobantes adeudados.',
    placement: 'bottom',
    pad: 6,
  },
  {
    targetId: 'recibo-emision',
    title: 'Datos de emisión',
    body: 'Elegí la sucursal, el grupo de caja y la fecha de emisión. Podés agregar observaciones al recibo.',
    placement: 'left',
    pad: 4,
  },
  {
    targetId: 'recibo-comprobantes',
    title: 'Comprobantes adeudados',
    body: 'Mirá el saldo vigente y vencido, y seleccioná los comprobantes que cancela este recibo. Con «Pagar todo» los aplicás todos de una vez.',
    placement: 'right',
    pad: 4,
  },
  {
    targetId: 'recibo-medios',
    title: 'Medios de cobro',
    body: 'Con «Agregar pago» cargás cómo paga el cliente: efectivo, cheque, transferencia, tarjeta u otros.',
    placement: 'left',
    pad: 4,
  },
  {
    targetId: 'recibo-resumen',
    title: 'Resumen',
    body: 'Compará el total aplicado con el total de medios. Si sobra, queda a cuenta; si falta, no se puede procesar.',
    placement: 'left',
    pad: 4,
  },
  {
    targetId: 'recibo-procesar',
    title: 'Procesar pago',
    body: 'Cuando los importes cierran, procesá el pago para emitir el recibo.',
    placement: 'top',
    pad: 6,
  },
];

export const RECIBOS_LISTADO_TOUR: PageTourDefinition = {
  id: 'recibos-listado',
  steps: RECIBOS_LISTADO_STEPS,
  continueTo: `${ROUTES.tesoreria.recibos.nuevo}?tour=1`,
  continueLabel: 'Ir a nuevo recibo',
};

export const RECIBO_NUEVO_TOUR: PageTourDefinition = { id: 'recibo-nuevo', steps: RECIBO_NUEVO_STEPS };
